module.exports = __webpack_public_path__ + "static/media/icn-plus-20px.b33e67b3.svg";